import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MultiSelectFilter } from "../../interfaces/multi-select-filter";

@Component({
    selector: 'app-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
  })
  export class MultiSelectComponent {
    @Input({ required: true }) filterItems!: MultiSelectFilter[];
    @Input() label: string = '';
    @Input() disabled: boolean = false;
    @Input() selectedValue: any[] = [];

    @Output() changeValue: EventEmitter<any[]> = new EventEmitter<any[]>();
    
    valueChange() {
      this.changeValue.emit(this.selectedValue);
    }
  }